import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../Store";
import TimeDisplay from "./TimeDisplay";

const EventsComponent = () => {
  const { casesStore } = useStore();
  const { t } = useTranslation();
  const brand = casesStore.brand;

  const caseEvents: JSX.Element[] = [];
  const caseEvents2: JSX.Element[] = [];
  
  if (casesStore.events != null) {
    casesStore.events.forEach((item, index) => {
      const key = `eventContainer-${index}-${item.eventType}-${item.eventDateTime}`;
      if (item.eventType === 1) {
        caseEvents.push(
          <li key={key}>
            <div className="row">
              <div className="circle"/>   
              <p className={`status-container-event-name status-text product-font-${brand}`}>{t(`statuscontainerevent${item.eventType}`)}</p>
            </div>
            <div className="row line-container margin--top-10">
              <div className="line"/>
              <div className="margin--left-20">
                <p className={`status-container-event-time time grey-text product-font-${brand}`}>
                  <TimeDisplay dateTime={item.eventDateTime} />
                </p>
              </div>
            </div>
          </li>
        );
      } else {
        caseEvents2.push(
          <li key={key}>
            <div className="row">
              <div className="circle"/>   
              <p className={`status-container-event-name status-text product-font-${brand}`}>{t(`statuscontainerevent${item.eventType}`)}</p>
            </div>
            <div className="row line-container margin--top-10">
              <div className="line"/>
              <div className="margin--left-20">
                <p className={`status-container-event-time time grey-text product-font-${brand}`}>
                  <TimeDisplay dateTime={item.eventDateTime} />
                </p>
              </div>
            </div>
          </li>
        );
      }
    });

    return (
      <div id="status-container">
        <div className={`status-container-header product-font-${brand}`}>
          <p>{t("EventsTitle")}</p>
        </div>
        <div className={`events-container-base product-${brand}`}>
          <ul className="active">
            {caseEvents}
            {caseEvents2}
          </ul>   
        </div>
      </div>
    );
  }

  return <div className="loading-bar"></div>;
};

export default observer(EventsComponent);